import { defineMessages } from 'react-intl-next';

export default defineMessages({
    modalTitle: {
        defaultMessage: 'Clear conversation?',
        description: 'Modal title for clear conversation confirmation.',
        id: 'help-center.conversation.clear.conversation.modal.title',
    },
    modalBody: {
        defaultMessage: 'Your conversation history will be lost.',
        description: 'Modal body for clear conversation confirmation.',
        id: 'help-center.conversation.clear.conversation.modal.body',
    },
    modalCancelButton: {
        defaultMessage: 'Cancel',
        description: 'Cancel button for clear conversation modal.',
        id: 'help-center.conversation.clear.conversation.modal.cancel.button',
    },
    modalClearButton: {
        defaultMessage: 'Clear',
        description: 'Clear button for clear conversation modal.',
        id: 'help-center.conversation.clear.conversation.modal.clear.button',
    },
});
